import {MI} from "../init";

import WinControl from "./WinControl";
import {madnes_end_freespins, madnes_end_round} from "../../framework/src/engine/madnes/madnes";
import ServerResultWinline from "../ServerResultWinline";
import BigWin from "./BigWin";
import WinCounter from "./WinCounter";
import WinViewer from "./WinViewer";
import FreeSpinsWinCounter from "./FreeSpinsWinCounter";
import {server_result, set_server_result, states} from "../../framework/src/engine/madnes/madnes_variables";
import {STATES} from "../../framework/src/states/states";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import events from "../../framework/src/events/EventsObservable";

/**
 * @constructor
 * @param {Game} game
 * @param {SymbolsManager} symbolsManager
 * @returns {ResultController}
 */
export default function ResultController(game, symbolsManager) {
    /** @type {Game} */
    this._game = game;

    this._sounds = game.sounds;

    /** @type {SymbolsManager} */
    this._symbolsManager = symbolsManager;

    this._controlLinePos = 0;
    this._controlResultPos = 0;

    /**
     * @type {Array|undefined}
     */
    this._lineWins;

    /** @type {ServerResult} */
    this._serverResult;

    /** @type {WinControl} */
    this._winControl;

    /** @type {Promise|null} */
    this.bigwinPromise = null;

    /** @type {Function|null} */
    this.bigwinResolver = null;

    this.inBigWin = false;

    this._roundWinTotal = 0;

    //this._lossCount = 0;

    this._isWin = false;

    this._forceAutostart = false;

    this._inAnimWinAdd = false;

    this._disableFsEnd = false;
};

ResultController.prototype.init = function() {
    this._winControl = new WinControl(this._game, this, this._symbolsManager, this._serverResult);
};

/**
 * @param {boolean} bool
 */
ResultController.prototype.setDisableFsEnd = function(bool) {
    this._disableFsEnd = bool;
};

ResultController.prototype.incControlResultPos = function() {
    return ++this._controlResultPos;
};

/**
 * @returns {number}
 */
ResultController.prototype.getControlResultPos = function() {
    return this._controlResultPos;
};

/**
 * @returns {number}
 */
ResultController.prototype.getControlLinePos = function() {
    return this._controlLinePos;
};

ResultController.prototype.getRoundWinTotal = function(serverResult) {

    var total = 0;
    var lineWins = serverResult.getLineWins();

    if(lineWins) {
        for(var i = 0; i < lineWins.length; i++) {

            if(typeof lineWins[i]['win'] !== 'undefined') {
                total += lineWins[i]['win'];
            }
        }
    }

    return total;
};

/**
 * @param {boolean} b
 */
ResultController.prototype.setForceAutostart = function(b) {
    this._forceAutostart = b;
};

/** @returns {boolean} */
ResultController.prototype._isForceAutostart = function() {
    return this._forceAutostart;
};

/**
 * @param {ServerResult} serverResult
 */
ResultController.prototype.control = function(serverResult) {
    var _self = this;

    if(this._inAnimWinAdd) //still running win add animation
    {
        setTimeout(function() {
            _self.control(serverResult);
        }, 150);
        return;
    }

    this._serverResult = serverResult;
    this._lineWins = serverResult.getLineWins();

    this._controlLinePos = 0;
    this._controlResultPos = 0;

    this._roundWinTotal = this.getRoundWinTotal(serverResult);

    // MI.controls.unsetForceStop();
    MI.setState("ROTATED", 0);


    this._isWin = false;

    this._controlWin();

    if(!this._getActualLineWin()) { //no win
        var soundName = this._game.inFreeSpins ? "bg_FreeSpins_Loop" : "bg_Music";

        this._sounds[soundName].fadeToInit(500);

        if(!this._sounds[soundName].isPlaying()) {
            this._sounds[soundName].loop();
        }
    }

};

ResultController.prototype._controlWinNext = function() {
    this._controlLinePos++;
    this._controlWin();
};

ResultController.prototype._controlWin = function() {

    var _self = this;
    var lineWin = this._getActualLineWin();

    if(!lineWin) {
        this._winControl.end();
        this._endControl();
        return;
    }

    MI.controls.hideStop();

    this._game.setForceAutostartEnabled(false);

    this._isWin = true;

    var resultWinline = new ServerResultWinline();
    resultWinline.init(lineWin);

    var control = this._winControl.init();
    this._winControl.setNextWinLine(this._getLineWin(this._controlLinePos + 1));
    this._winControl.run(resultWinline, this._serverResult);

    control.then(function() {
        _self._controlWinNext();
    });
};

/** @returns {boolean} */
ResultController.prototype.isBigWin = function() {
    return this._roundWinTotal >= MI.getBigWinFactor() * MI.getMoneyBet();
};

ResultController.prototype._getLineWin = function(index) {
    return this._lineWins && this._lineWins[index];
};

ResultController.prototype._getActualLineWin = function() {
    return this._getLineWin(this._controlLinePos);
};

/** @returns {number} */
ResultController.prototype._getLineWinCountLeft = function() {
    return this._lineWins ? Object.keys(this._lineWins).length - this._controlLinePos : 0;
};

/**
 * @param {boolean=} fromBigWin
 */
ResultController.prototype._endControl = function(fromBigWin) {

    var _self = this;
    if(this.inBigWin && this.bigwinPromise) {
        this.inBigWin = false;

        this.bigwinPromise.then(function() {
            _self._game.spinReels.fadeInStandAnim();
            _self._game.spinReels.createShineAnim();
            _self._endControl(true);
        });
        return;
    }

    this.bigwinPromise = null;

    this._audioEnd(fromBigWin);

    this._endRound(fromBigWin);
};

ResultController.prototype._audioEnd = function(fromBigWin) {

    //console.log((this._game.inFreeSpins && !this._game.isNextRoundFreeSpin()), this._game.inFreeSpins, !this._game.isNextRoundFreeSpin());

    if(/*!this._isWin || fromBigWin || */(this._game.inFreeSpins && !this._game.isNextRoundFreeSpin())) {
        return;
    }

    var soundName = this._game.inFreeSpins ? "bg_FreeSpins_Loop" : "bg_Music";

    if(fromBigWin) {
        this._sounds[soundName].loop();
        this._sounds[soundName].setVolume(0);
    }

    if(this._sounds[soundName].isPaused()) {
        this._sounds[soundName].continue();
    }

    //console.log('fadeto: 1 ', soundName, 200, "_controlWin end");
    this._sounds[soundName].fadeTo(600, this._sounds[soundName].getInitVolume(), function() {
        //console.log('fadedTo: 1 ', soundName, 200, "_controlWin end");
    }.bind(this));

};

ResultController.prototype._endFreeSpinRound = function() {

    var _self = this;

    if(this._disableFsEnd) {
        this._disableFsEnd = false;
        // MI.server.setRoundRunning(true);
        // MI.controls.showAllBtns();
        // MI.controls.showSpin();
        // this._endResultControl(true);
        // return;
    }

    // var fsWin = this._serverResult.getLinesWinTotal(); //this._game.freeSpinData["roundWin"];
    // var fsPos = this._game.inFreeSpinsIndex + 1;
    // var fsCount = this._game.freeSpinData["count"];

    if(this._game.isNextRoundFreeSpin()) {

        _self._game.freeSpinData["roundWin"] = 0;
        madnes_end_round();

        // this._endRoundServer(false, {},{ win: fsWin, order: fsPos, count: fsCount }).then(function() {
        //
        // 	MI.server.setRoundRunning(true);
        // 	MI.controls.showAllBtns();
        // 	MI.controls.showSpin();
        //
        // 	if(_self._game.inFreeSpinsIndex >= 0) {
        // 		MI.setCookie("lfspos_" + MI.server.getSessionId(), _self._game.inFreeSpinsIndex);
        // 	}
        //
        // 	_self._game.freeSpinData["roundWin"] = 0;
        //
        // 	_self._endResultControl(true);
        // });

    } else {

        madnes_end_freespins();

        this._game.assets.colorizeAllFrames(this._game.spinReels);
        this._game.assets.showLightFramesFs();
        this._game.assets.fadeOutFreeSpin();

        var win = MI.getWin();

        this._runFS(MI.moneyToCoin(win)).then(function() {

            madnes_end_round();

            // var betRemoved = false;

            // _self._game.isInAutostart() && MI.controls.showAllBtns();

            // _self._endRoundServer(true, {}, { win: fsWin, order: fsPos, count: fsCount }).then(function() {
            //
            // 	// betRemoved = _self._game.isInAutostart();
            //
            // 	MI.setCookie("lfspos_" + MI.server.getSessionId(), "", -1);
            //
            // 	// MI.controls.showAllBtns();
            // 	// MI.controls.hideStop();
            //
            // 	_self._endResultControl(false);
            // });
        });
    }
};

/**
 * @param {boolean=} fromBigWin
 */
ResultController.prototype._endRound = function(fromBigWin) {

    MI.controls.winAnimReset();

    if(this._game.inFreeSpins) {

        this._endFreeSpinRound();

    } else if(fromBigWin) {

        this._endRoundBigWin();

    } else if(this._game.getWin() > 0 && !fromBigWin) {

        MI.setInMoneyAdd(true);
        this._endRoundWin();
    } else {
        this._endRoundNoWin();
    }
};

ResultController.prototype._endRoundNoWin = function() {

    var _self = this;

    madnes_end_round();

    // _self._game.isInAutostart() && MI.controls.showAllBtns();

    // this._endRoundServer(true, {}, {}).then(function() {
    // 	_self._endResultControl(false);
    // });
};

ResultController.prototype._endRoundBigWin = function() {
    // var _self = this;

    // states.setState(STATES.BONUS_WIN);

    madnes_end_round();

    // this._endRoundServer(true, {}, {}).then(function() {
    //
    // 	_self._endResultControl(false);
    //
    // });
};

ResultController.prototype._endRoundWin = function() {
    var _self = this;
    var won = this._game.getWin();

//	var counterEnded = false;

    this._inAnimWinAdd = true;

    var winViewer = new WinViewer(this._game);
    winViewer.create(MI.moneyToCoin(won));

    // _self._game.isInAutostart() && MI.controls.showAllBtns();

    // MI.controls.hideSkip();

    winViewer.run().then(function() {
        _self._inAnimWinAdd = false;
    }).then(function() {

        //return _self._endRoundServer(true, {}, {});
        madnes_end_round();

    });/*.then(function() {

		_self._endResultControl();
	});*/
};

/**
 */
ResultController.prototype._endResultControl = function(inFreespins) {

    // MI.setInMoneyAdd(false);
    // // MI.controls.showAllBtns();
    //
    // if(!inFreespins) {
    // 	madnes_on_end_round_recount(win);
    // 	madnes_on_round_end();
    // 	madnes_recount_bet();
    // }
    //
    // this._game.spinEnabled = true;
    //
    // this._game.setForceAutostartEnabled(false);
    // if(this._game.isInAutostart() || this._isForceAutostart())
    // {
    // 	this.setForceAutostart(false);
    //
    // 	MI.rotateStart();
    // 	return;
    // }
};

/**
 * @param {boolean} ended
 * @param {Object=} roundData
 * @param {Object=} fsData
 * @returns {Promise}
 */
ResultController.prototype._endRoundServer = function(ended, roundData, fsData) {
//	MI.controls.showStop();
//	MI.controls.hideSpin();
    return MI.server.endRound(ended, roundData, fsData);
};

ResultController.prototype.runBigWin = function() {

    var _self = this;

    _self._game.spinReels.fadeOutStandAnim();
    _self._game.spinReels.stopShineAnim();

    var soundName = this._game.inFreeSpins ? "bg_FreeSpins_Loop" : "bg_Music";
    this._sounds[soundName].fadeOut(1000, true);

    MI.controls.hideAllBtns();

    this.inBigWin = true;
    events.dispatch(GAME_EVENTS.GAME_BIGWIN);


    this.bigwinPromise = new Promise(function(res) {
        _self.bigwinResolver = res;
    });

    var bigwin = new BigWin(this._game);

    bigwin.create();

    _self._sounds["bwin_BigWin"].play();

    this._game.spinReels.fadeInBlackScreenPost().then(function() {

        return bigwin.dustStart(500).then(function() {

            bigwin.moveShines();
        }).then(function() {

            return bigwin.scaleInSign();
        });

    })/*.then(function() {

		return new Promise(function(res) { setTimeout(res, 1000); });

	})*/.then(function() {

        return _self._game.spinReels.fadeOutBlackScreen();

    }).then(function() {

        _self.runBigWinCounter(bigwin);
        _self._controlWin();
    });
};

/**
 * @param {BigWin} bigwin
 */
ResultController.prototype.runBigWinCounter = function(bigwin) {

    var _self = this;

    this._sounds["ui_Counter"].loop();

    bigwin.animTextBgDustStart();

//	var obj = { 'value': 0 };

    //this._serverResult.getWin()

    var counter = new WinCounter(this._game);
    counter.setOnUpdate(function(v) {
        bigwin.setText(v | 0);
    });
    counter.setOnEnd(function() {
        bigwin.animTextBgDustStop();

        _self._sounds["bwin_BigWin"].stop();
        _self._sounds["bwin_BigWin_End"].play();
        _self._sounds["ui_Counter"].stop();

        setTimeout(function() {
            _self._sounds["ui_Counter_Stop"].play();
        }, 300);

        bigwin.setText(MI.moneyToCoin(_self._roundWinTotal));
        var p1 = bigwin.stopShines();
        var p2 = bigwin.pulseText();

        Promise.all([p1, p2]).then(function() {
            bigwin.destroy();

            _self._game.spinReels.playShineAnim();
            _self.bigwinResolver();

        });
    });

    counter.run(0, MI.moneyToCoin(this._roundWinTotal), this.getBigWinDuraiton());

//	MI.addTween().to(obj, { 'value': MI.moneyToCoin(this._roundWinTotal) }, {
//		'duration': this.getBigWinDuraiton(), //this._getLineWinCountLeft() * 2000 + 1000,
//		'update': function() {
//			bigwin.setText(obj['value']);
//		},
//		'callback': function() {
//
//			bigwin.animTextBgDustStop();
//
//			_self._sounds["bwin_BigWin"].stop();
//			_self._sounds["bwin_BigWin_End"].play();
//			_self._sounds["ui_Counter"].stop();
//
//			setTimeout(function() {
//				_self._sounds["ui_Counter_Stop"].play();
//			}, 300);
//
//			bigwin.setText(MI.moneyToCoin(_self._roundWinTotal));
//			var p1 = bigwin.stopShines();
//			var p2 = bigwin.pulseText();
//
//			Promise.all([p1, p2]).then(function() {
//				bigwin.destroy();
//
//				_self._game.spinReels.playShineAnim();
//				_self.bigwinResolver();
//
//			});
//		}
//	});
};

/**
 * @returns {number}
 */
ResultController.prototype.getBigWinDuraiton = function() {

    var duration = 1000;

    for(var i = 0; i < this._lineWins.length; i++) {

        if(this._lineWins[i]["type"] === "normal") {
            duration += 900;
        }

        if(this._lineWins[i]["type"] === "wild") {
            duration += 1900;
        }
    }

    return duration;
};

/**
 * @param {number} won
 * @returns {Promise}
 */
ResultController.prototype._runFS = function(won) {

    var _self = this;

    states.setState(STATES.BONUS);

    // MI.controls.hideAllBtns();

    _self._game.spinReels.stopShineAnim();
    _self._game.spinReels.fadeOutStandAnim();

    var bw = new BigWin(this._game);

    setTimeout(function() {
        //console.log("fadeTo 0:", "bg_FreeSpins_Loop", 850, "_runFS");
        _self._sounds["bg_FreeSpins_Loop"].fadeTo(850, 0, function() {
            //console.log("stopped: bg_FreeSpins_Loop", 850, "_runFS");
            _self._sounds["bg_FreeSpins_Loop"].stop();
        });
    }, 200);

    this._game.spinReels.stopShineAnim();

    bw.createFreeSpin();

    return this._game.spinReels.fadeInBlackScreenPost().then(function() {

        _self._sounds["bwin_FreeSpins"].play();

        return bw.dustFSStart().then(function() {
            bw.moveShines();
        }).then(function() {
            return bw.scaleInSignFS();
        }).then(function() {

            _self._sounds["ui_Counter"].loop();

            var fsc = new FreeSpinsWinCounter(MI.getBet(), won);
            fsc.onUpdate(function(val) {
                bw.setText(val);
            });
            fsc.onComplete(function(val) {
                _self._sounds["ui_Counter"].stop();
                _self._sounds["ui_Counter_Stop"].play();
                bw.setText(val);
            });

            return fsc.run();
        });

    }).then(function() {

        bw.smokeOutFs();

        return new Promise(function(res) {
            setTimeout(res, 1200);
        });
    }).then(function() {

        //_self._sounds["bg_Music"].continue();
        _self._sounds["bg_Music"].loop(0.01);
        _self._sounds["bg_Music"].fadeTo(1000, _self._sounds["bg_Music"].getInitVolume());

        var p1 = bw.stopShines();
        var p2 = bw.fadeOutSignFS(1500);
        return Promise.all([p1, p2]);

    }).then(function() {

        //MI.controls.showAllBtns();

        return _self._game.spinReels.fadeOutBlackScreen();

    }).then(function() {

        bw.destroy();
        _self._game.spinReels.fadeInStandAnim();
        _self._game.spinReels.createShineAnim();

        _self._game.leaveFreeSpins();
    });
};

//ResultController.prototype._wait = function(time) {
//	return new Promise(function(res) {
//		MI.createTimer().add(res, time);
//	});
//};